import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import { useLocales } from "@/locales";
import CodeSnippet from "@/components/CodeSnippet";
import { Trans } from "react-i18next";
import Table from "@/DocLayout/Table/index";

export default function InvoiceWebhookAPI() {
  const { translate } = useLocales();
  const invoice_webhook = {
    response: `{
  "type": "ApiDeposit",
  "msg": {
    "recordId": "20240919035020188328269786624000",
    "orderId": "1726717497",
    "coinId": 2541,
    "coinSymbol": "POL",
    "status": "Success"
  }
}`,
    go: {
      http_ex_code: ``,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: ``,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: ``,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: ``,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: ``,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <>
      <ContentWrap
        id="webhook-api-deposit"
        showBorderBottom={false}
        leftChildrenSx={{
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box
              id="webhook-api-deposit"
              component={"div"}
              className="title_0"
              mt={3}
            >
              {translate("merchant_app_mode_API.text_154")}
            </Box>

            <Box component={"div"} className="desc" mt={3}>
              <Trans
                i18nKey={"merchant_app_mode_API.text_155"}
                t={translate as any}
              >
                Just a placeholder
                <a href={"#invoice-api-info"} className="link">
                  Just a placeholder
                </a>
              </Trans>
            </Box>
          </CommonWrap>
        }
      />
      <ContentWrap
        showBorderBottom={false}
        leftChildrenSx={{
          paddingTop: "32px",
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_155_")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_156"),
                },
                {
                  name: "orderId",
                  type: "String",
                  desc: translate("merchant_app_mode_API.text_157"),
                },
                {
                  name: "coinId",
                  type: "Integer",
                  desc: translate("merchant_app_mode_API.text_158"),
                },
                {
                  name: "coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_159")}`,
                },
                {
                  name: "status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${translate(
                          "merchant_app_mode_API.text_160"
                        )} ` as any,
                      }}
                    />
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_request_ex")}
              code={invoice_webhook.response}
            />
          </>
        }
      />
    </>
  );
}
